/** Convert board-local % (pin center) to MapViewport frame pixels (after board rotate). */
export function boardPctToFramePx(
  xPct: number,
  yPct: number,
  boardW: number,
  boardH: number,
  rotationDeg: 0 | 90 | 180 | 270,
): { fx: number; fy: number } {
  const lx = (xPct / 100 - 0.5) * boardW;
  const ly = (yPct / 100 - 0.5) * boardH;
  const θ = (rotationDeg * Math.PI) / 180;
  const cos = Math.cos(θ);
  const sin = Math.sin(θ);
  const sx = lx * cos - ly * sin;
  const sy = lx * sin + ly * cos;
  const rw = rotationDeg === 90 || rotationDeg === 270 ? boardH : boardW;
  const rh = rotationDeg === 90 || rotationDeg === 270 ? boardW : boardH;
  return { fx: rw / 2 + sx, fy: rh / 2 + sy };
}
